import _ from 'lodash'
import { UUID } from '@/plugins/common'
import Column from './column'
import Filter from './filter'
import Button from './button'
import Order from './order'
import Group from './group'
import Join from './join'
import Children from './children'
import AppReportModel from './appReportModel.js'
import { Expression } from '@/shared/expressdion'

export default class Report {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      name: '',
      mainTableId: '',
      groupByEnable: false,
      securityEnable: false,
      advancedFilter: false,
      conditionsRequired: false,
      dataSourceReport: '',
      columns: [],
      filters: [],
      buttons: [],
      orderBies: [],
      groupBies: [],
      freezeLeft: 0,
      freezeRight: 0,
      joins: [],
      children: [],
      filterExpression: '',
      // 系统默认筛选方式默认(默认普通的方式)
      systemFilterSwitch: false,
      groupFilterExpressionStr: '',
      operationPosition: false,
      appModel: {},
      appSwitch: false,
      // 分页大小
      pageNumber: 10,
      // 开启批量处理
      batchHandle: false,
      // 打开时不加载数据
      openStartLoadData: false,
      // 报表行间隔背景色
      bgColor: true,
      // 历史备注信息
      comment: '',
      // 组合报表
      groupReportData: [],
      isGroupReportSign: true,
      reportType: '1',
      dimensionality: [],
      norm: {},
      // 合并同名
      mergeSame: [],
      // 开启列编辑
      columnEdit: false,
      // 选择编辑列
      editColumns: [],
      // 选择表单
      editColumnForm: '',
      kanBanProperties: {
        //  分类列的表id
        classificationTableId: '',
        //  分类列字段id
        classificationColumnId: '',
        //  分类列报表id
        classReportColumnId: '',
        //  展示列的表id
        showColumnTableId: '',
        //  展示列字段id
        showColumnId: '',
        //  展示列报表id
        showReportColumnId: '',
        //  主表tableId
        mainTableId: '',
        //  数字列的报表字段id（执行根据该id取数字列的值）
        numberReportColumnId: '',
        //  数字列的字段id（执行新增修改时所用的归档字段id）
        numberColumnId: ''
      }
    }
    if (args.columns) {
      this.columns = args.columns.map(m => {
        if (!m.columnId) {
          m.columnId = m.expressionText && m.expressionText.match(/\$\{(.+?)\}/g) && m.expressionText.match(/\$\{(.+?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
        }
        return new Column(m)
      })
      this.columns = _.sortBy(this.columns, (item) => {
        return item.sort
      })
    }
    if (args.filters) {
      this.filters = args.filters.map((m, index) => {
        if (!m.position) {
          let position = {}
          position.sizex = 1
          position.sizey = 1
          m.position = position
          m.position.col = (index + 1) % 4
          m.position.row = (index + 1) / 4
        }
        return new Filter(m)
      })
    }
    if (args.buttons) {
      args.buttons = args.buttons.map(m => {
        return new Button(m)
      })
    }
    if (args.orderBies) {
      args.orderBies = args.orderBies.map(m => {
        return new Order(m)
      })
    }
    if (args.groupBies) {
      args.groupBies = args.groupBies.map(m => {
        return new Group(m)
      })
    }
    if (args.joins) {
      args.joins = args.joins.map(m => {
        return new Join(m)
      })
    }
    if (args.children) {
      args.children = args.children.map(m => {
        return new Children(m)
      })
    }
    this.appModel = AppReportModel.create(args.appModel)
    _.defaults(this, args, defaults)
  }

  static create (args) {
    let report = new Report(args)
    return report
  }

  load (report) {
    report.appModel = AppReportModel.load(report.appModel)
    _.merge(this, report)
  }

  createOrUpdate (object) {
    let contexts = this.getContext(object)
    let sort = object.sort
    let context = contexts.find(m => m.id === object.id)
    object.reportId = this.id
    if (context) {
      // 修改的情况下, 直接改值
      _.merge(context, object)
    } else if (object.sort || object.sort === 0) {
      if (contexts.length <= sort) {
        // 阻止他上天
        object.sort = contexts.length
      }
      contexts.push(object)
    } else {
      contexts.push(object)
    }
  }

  getContext (object) {
    let context
    if (object instanceof Column) {
      context = this.columns
    } else if (object instanceof Filter) {
      context = this.filters
    } else if (object instanceof Button) {
      context = this.buttons
    } else if (object instanceof Order) {
      context = this.orderBies
    } else if (object instanceof Group) {
      context = this.groupBies
    } else if (object instanceof Join) {
      context = this.joins
    } else if (object instanceof Children) {
      context = this.children
    } else {
      throw new Error('不存在的东西')
    }
    return context
  }

  resetReport () {
    this.columns = []
    this.filters = []
    this.buttons = []
    this.orderBies = []
    this.groupBies = []
    this.joins = []
    this.children = []
    this.mainTableId = ''
    this.freezeLeft = 0
    this.freezeRight = 0
    this.filterExpression = ''
    this.groupFilterExpressionStr = ''
    this.groupByEnable = false
    this.securityEnable = false
    this.advancedFilter = false
    this.mainTableId = ''
    this.conditionsRequired = false
    this.systemFilterSwitch = false
    this.operationPosition = true
    this.batchHandle = false
    this.openStartLoadData = false
    this.groupReportData = []
    this.isGroupReportSign = true
    this.dimensionality = []
    this.norm = {}
    this.mergeSame = []
  }

  delete (object) {
    let arr = this.getContext(object)
    let index = arr.findIndex(m => m.id === object.id)
    if (index > -1) {
      arr.splice(index, 1)
    }

    if (object instanceof Column) {
      // 列的删除需要同时删除排序, 筛选
      let orderIndex = this.orderBies.findIndex(m => m.columnId === object.id)
      if (orderIndex > -1) {
        this.orderBies.splice(orderIndex, 1)
      }

      let filter = this.filters.find(m => m.columnId === object.id && m.filterType !== 'senior')
      // 先删除普通搜索框
      if (filter) {
        _.remove(this.filters, (m) => {
          return m === filter
        })
      }
      filter = this.filters.find(m => m.columnId === object.id && m.filterType === 'senior')
      // 删除前置筛选框
      if (filter) {
        _.remove(this.filters, (m) => {
          return m === filter
        })
        // 防止旧数据出错, 先去掉所有的空格
        this.filterExpression = this.filterExpression.replace(/ /g, '')
        let str = `\\$\\{${filter.id}}`
        this.filterExpression = this.filterExpression.replace(new RegExp(str, 'g'), '')
        // 清除左边不是 }/) 的运算符
        this.filterExpression = this.filterExpression.replace(/[^}|^)][&||]/g, '')
        // 清除右边边不是 $/( 的运算符
        this.filterExpression = this.filterExpression.replace(/[&||][^(|^$]/g, '')
        // 清除所有的空括号
        this.filterExpression = this.filterExpression.replace(/\(\)/g, '')
      }
    }
  }

  checkUsed (columnId) {
    if (this.filters.some(m => m.columnId === columnId)) {
      return {'state': true, 'context': '列被筛选条件所引用'}
    } else if (this.orderBies.some(m => m.columnId === columnId)) {
      return {'state': true, 'context': '列被排序所引用'}
    } else {
      return false
    }
  }

  handleSenior (isUseDatasource, selectTable) {
    if (this.filterExpression && this.filterExpression !== '') {
    // 高级筛选未开启高级模式
      if (this.systemFilterSwitch === false) {
        let filters = this.filters
        let columns = this.columns
        let expression = this.filterExpression
        this.filterExpression.match(/\$\{(.+?)\}/g).forEach(m => {
          let filterId = m.substring(2, m.length - 1)
          let filter = filters.find(filter => filter.filterId === filterId)
          let column = columns.find(column => column.id === filter.columnId)
          if (isUseDatasource) {
            let sourceColumn = selectTable.columns.find(sourceColumn => sourceColumn.id === column.columnId)
            if (column) {
              expression = expression.replace(m, sourceColumn.expressionText + Expression.getOperation(filter.type) + "'" + filter.defaultValue + "'")
            }
          } else {
            if (column) {
              expression = expression.replace(m, column.expressionText + Expression.getOperation(filter.type) + "'" + filter.defaultValue + "'")
            }
          }
        })
        this.filterTempExpression = expression
      } else {
        this.filterTempExpression = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/report/report.js